export const manifest = {
  screens: {
    scr_z993ie: { name: "Home", route: "/" },
  },
}
